<template>
  <transition name="toast-info">
    <div class="toast" v-show="theToast">
      {{ msg }}
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      theToast: false,
      msg: '',
    }
  },
}
</script>

<style lang="less" scoped>
.toast {
  .sizeColor(24px, #fff);
  .center(50px);
  position: fixed;
  bottom: 51%;
  left: 50%;
  padding: 0 20px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transform: translateX(-50%);
  z-index: 9000;
}

.toast-info-enter-active,
.toast-info-leave-active {
  transition: 0.3s ease-out;
}

.toast-info-enter {
  opacity: 0;
}

.toast-info-leave-to {
  opacity: 0;
}
</style>
